import { render } from "./ConsumptionRecords.vue?vue&type=template&id=6800821c&scoped=true"
import script from "./ConsumptionRecords.vue?vue&type=script&lang=js"
export * from "./ConsumptionRecords.vue?vue&type=script&lang=js"

import "./ConsumptionRecords.vue?vue&type=style&index=0&id=6800821c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6800821c"]])

export default __exports__